import store from './store';

export default {
  id: 0,
  async request(method, payload) {
    this.id++;
    let request = {
      id: this.id,
      method: method,
      params: [payload],
    }
    let resp = await fetch("/api/rpc", {
      method: "POST",
      body: JSON.stringify(request),
      credentials: 'include',
      headers: {
        'Content-type': 'application/json',
        'Authorization': store.state.token
      }
    });

    let jsonResp = await resp.json();
    if(jsonResp.error) {
      throw jsonResp.error;
    }
    return jsonResp.result;
  }
}